import React from "react";
import $ from "jquery";

const SharePopup = (props) => {
  let link = props.link;
  var share_text = props.quote;
  share_text = share_text ? share_text.split("#").join("") : "";
  let tlink = "https://twitter.com/intent/tweet?text=";
  let flink = "https://www.facebook.com/dialog/feed?app_id=445815495479697";
  var facebookLink = `${flink}&link=${encodeURIComponent(
    link
  )}&quote=${share_text}&www.facebook.com=1`;
  var twitterLink = `${tlink} ${encodeURIComponent(
    props.twittermessage + "\n\n" + link
  )}&www.facebook.com=1`;
  var whatsappLink =
    "https://api.whatsapp.com/send?text=" +
    encodeURIComponent(props.quote + " " + link);

  return (
    <div
      className="popup_fixed_bg"
      id="share_popup_box_main"
      style={{ display: "none" }}
    >
      <div className="popup_bg">
        <h4 className="share_popup_h4">
          Share
          <a
            href="javascript:void(0);"
            onClick={() => {
              $(".popup_fixed_bg").hide();
            }}
            className="crossbtnshare"
          >
            <img src="/assets/images/crossorange.svg" className="" />
          </a>
        </h4>

        <ul className="d-flex justify-content-center align-items-center">
          <li>
            <figure>
              <a href={facebookLink} target="_blank">
                <img
                  src="/assets/images/facebook.svg"
                  className="share_icons"
                />
                <figcaption>{"Facebook"}</figcaption>
              </a>
            </figure>
          </li>
          <li>
            <figure>
              <a href={twitterLink} target="_blank">
                <img
                  src="/assets/images/twiiterblack.svg"
                  className="share_icons"
                />
                <figcaption>{"Twitter"}</figcaption>
              </a>
            </figure>
          </li>
          <li>
            <figure>
              <a href={whatsappLink} target="_blank">
                <img
                  src="/assets/images/whatsapp.svg"
                  className="share_icons"
                />
                <figcaption>{"Whatsapp"}</figcaption>
              </a>
            </figure>
          </li>
        </ul>
      </div>
    </div>
  );
};
export default SharePopup;
